import styled from 'styled-components'
import {
  display,
  position,
  width,
  textAlign,
  left,
  opacity,
} from 'styled-system'
import { fadeInAnimation } from 'styles/animation'
import { transitions } from 'polished'
import theme from 'styles/theme'
import { fill } from 'styles/sharedStyle'
import { Box } from 'rebass'

import { GatsbyImage } from 'gatsby-plugin-image'
import { getBGColor, getBtnMainColor } from 'utils/themeUtils'

export const LTROverride = styled.div`
  direction: ltr;
`

export const Overlay = styled.div`
  display: flex;
  align-items: ${(props) => (props.isMobileOnly ? 'flex-start' : 'center')};
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  padding: ${theme.space[4]};
  width: 100vw;
  height: 100vh;
  background: hsla(0, 0%, 0%, 0.25);
  opacity: ${(props) => (props.isClosing ? 0 : 1)};
  animation: ${fadeInAnimation} 0.2s ease-in-out;
  transition: opacity 0.2s ease-in-out;
  z-index: 120;
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${theme.space[4]};
  width: calc(100vw - 40px);
  max-width: ${theme.maxWidths[1]};
  height: ${(props) => (props.isMobileOnly ? '84%' : '100%')};
  position: relative;

  background: ${getBGColor()};
  #carousel-item-modal--shop-contacts-large {
    display: none;
  }

  #carousel-item-modal--shop-contacts-small {
    display: flex;
    flex-direction: column;
    padding-top: ${theme.space[7]};
    padding-bottom: ${theme.space[7]};
  }

  #carousel-item-modal--close-large {
    display: none;
  }

  #carousel-item-modal--close-small {
    display: flex;
  }

  .slick-slider {
    width: calc(100vw - (${theme.space[4]} * 4));
  }

  a {
    color: ${theme.colors.sagedark};
    text-decoration: underline;
  }

  ${theme.mediaQueries.medium} {
    padding: ${theme.space[6]};
    padding-bottom: 0;
    height: auto;

    #carousel-item-modal--shop-contacts-small {
      display: none;
    }

    #carousel-item-modal--shop-contacts-large {
      display: flex;
      flex-direction: column;
    }

    #carousel-item-modal--close-large {
      display: flex;
      margin: 0px;
      padding: 0px;
      float: right;
    }

    #carousel-item-modal--close-small {
      display: none;
    }

    .slick-slider {
      padding-top: 50px;
      padding-left: 20px;
      height: 480px;
      width: auto;
      max-width: 540px;
    }
  }
`

export const ContentWrapper = styled.div`
  height: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
`

export const BrandLinkWrapper = styled.div`
  margin-bottom: ${theme.space[2]};
`

export const CloseButton = styled.button`
  display: flex;
  justify-content: flex-end;
  position: relative;
  top: -8px;
  right: -16px;
  background: none;
  border: none;
  > span {
    margin: 8px;
    height: 40px;
  }

  html[dir='rtl'] & {
    right: 0;
    left: -16px;
  }

  ${theme.mediaQueries.medium} {
    > span {
      margin: 0px;
      height: 40px;
    }
    right: -8px;

    html[dir='rtl'] & {
      right: 0;
      left: -8px;
    }
  }
`

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  /* border: 1px solid blue; */
`

export const ContactsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 0 0 ${theme.space[1]};

  a {
    ${transitions('border-color ease-in 0.2s')};
    cursor: pointer;
    border-bottom: 1px solid transparent;
    text-decoration: none;

    &:hover,
    &:focus {
      border-color: currentColor;
    }
  }
`

export const SliderWrapper = styled.div`
  .slick-list {
    overflow: ${(props) => (props.overflow ? 'visible' : 'hidden')};
  }
  /* Slider */
  .slick-slider {
    display: block;
    margin: 0px;
    padding: 0px;
    align-self: center;

    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
  }

  .slick-list {
    position: relative;

    display: block;
    /* overflow: hidden; */

    margin: 0;
    padding: 0;
  }
  .slick-list:focus {
    outline: none;
  }
  .slick-list.dragging {
    cursor: pointer;
    cursor: hand;
  }

  .slick-slide {
    display: none;
    float: left;

    height: 100%;
    min-height: 1px;
  }
  .slick-slide img {
    display: block;
  }
  .slick-slide.slick-loading img {
    display: none;
  }
  .slick-slide.dragging img {
    pointer-events: none;
  }
  .slick-initialized .slick-slide {
    display: block;
  }
  /* Dots */
  .slick-dots {
    position: absolute;
    display: block;
    width: 100%;
    height: 30px;
    padding: 0;
    margin: 0;
    padding-top: 10px;
    list-style: none;
    text-align: center;
  }
  .slick-dots li {
    position: relative;
    display: inline-block;
    width: 10px;
    height: 10px;
    margin: 0 5px;
    padding: 0;
    cursor: none;
    transition: width 0.3s ease-in-out;
  }

  /* Custom Slick Dots */
  .slick-dots li {
    width: 8px;
    height: 8px;
    transition: width 0.3s ease-in-out;
    background-color: transparent;
    border: 1px solid ${getBtnMainColor()};
  }

  .slick-dots .slick-active {
    width: 8px;
    height: 8px;
    transition: width 0.3s ease-in-out;
    background-color: ${getBtnMainColor()};
  }

  .slick-track {
    display: block;
    left: 0px;
    position: relative;
    top: 0;
  }
`

export const Image = styled.img`
  width: 150px;
  padding: 10px;
`

export const LeftWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;
  margin: 0px;
  padding-right: ${theme.space[3]};

  html[dir='rtl'] & {
    padding-left: ${theme.space[3]};
    padding-right: 0;
  }

  ${theme.mediaQueries.medium} {
    min-width: 360px;
  }
`

export const RightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;

  ${theme.mediaQueries.medium} {
    min-width: 480px;
  }
`

export const RightInnerWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const InnerWrapper = styled.div`
  display: block;
  flex: 1;
  position: relative;
  height: 100%;
  flex-direction: column;
  overflow-y: scroll;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: hsla(0, 0%, 0%, 0.25);
    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }

  ${theme.mediaQueries.medium} {
    flex-direction: row;
    overflow-y: hidden;
    display: flex;
  }
`

export const ImagePreview = styled.div`
  flex: 1;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-top: 40px;
`

export const ImagePreviewWrapper = styled.div`
  display: none;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-top: 30px;
  padding-bottom: ${theme.space[3]};

  ${theme.mediaQueries.medium} {
    display: flex;
    /* border: 1px solid black; */
    width: 100%;
  }
`

export const ProductPreviewCont = styled.div`
  /* display: inline-block; */
  height: 150vw;
  max-height: 180px;
  width: 20%;
  margin-left: ${(props) => (props.pl ? '25px' : '0px')};
`

export const ProductImgContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
`

export const ProductImg = styled(GatsbyImage)`
  display: flex;
  height: calc((100vw - (${theme.space[4]} * 4)));
  width: calc((100vw - (${theme.space[4]} * 4)) * 0.625);
  margin: 0 auto;
  background-color: white;

  img {
    background-color: white;
    object-fit: cover;
  }

  ${theme.mediaQueries.medium} {
    height: 480px;
    width: ${(props) =>
      props.image.height > 1 ? 480 / props.image.height : 480}px;
  }
`
export const ProductPreviewImg = styled(GatsbyImage)`
  height: 150vw;
  max-height: 180px;
  width: 100%;

  img {
    object-fit: cover;
  }
`
export const ProductCardList = styled.div`
  display: 0 0 auto;
  margin: 0 0 9px;

  html[dir='rtl'] & {
    flex-direction: row-reverse;
  }
`

export const ProductCardListItem = styled.div`
  margin-right: 7px;
  position: relative;

  html[dir='rtl'] & {
    margin-right: 0;
    margin-left: 7px;
  }

  &::before {
    background-color: ${theme.colors.sagemedium};
    content: '';
    display: ${(props) => (props.strikethrough ? 'block' : 'none')};
    height: 1px;
    left: 0;
    position: absolute;
    right: 0;
    top: 50%;
    transform: rotate(-3deg) translateY(-50%);
  }

  color: ${(props) =>
    props.strikethrough
      ? `${theme.colors.sagemedium}`
      : `${theme.colors.sagedark}`};
`

export const Logo = styled(Box)`
  ${display}
  ${position}
  ${width}
  ${textAlign}
  ${left}
  ${opacity}
  * {
    ${fill};
  }
`

export const StyledCarouselControls = styled.div`
  position: relative;
  right: ${theme.space[7]};
  bottom: -${theme.space[7]};
`

export const BottomArrowContainer = styled.div`
  display: flex;
  width: calc(100vw - 40px);
  max-width: ${theme.maxWidths[1]};
  height: 50px;
  align-self: center;
  background-color: rgba(225, 255, 255, 0);
  background-image: linear-gradient(rgba(225, 255, 255, 0), white);
  position: absolute;
  justify-content: center;
  align-items: center;
  right: 0;
  bottom: 0;
  left: 0;
  transition: all 0.15s ease;
  -moz-transition: all 0.15s ease;
  -webkit-transition: all 0.15s ease;

  ${theme.mediaQueries.medium} {
    display: none;
  }
`

export const ScrollToBottomComponent = styled.div`
  position: relative;
`
